export function yrs() {
	return [
		"2024",
		"2023",
		"2022",
		"2021",
		"2020",
		"2019",
		"2018",
		"2017",
		"2016",
		"2015",
		"2014",
		"2013",
	];
}

export function rnds() {
	return ["1", "2", "3", "4"];
}

/*
  export function socialIcons(obj) {
    let str = "&nbsp;";
    if (obj.twitter) {
      str += `<a href="https://twitter.com/${
        obj.twitter
      }"><i class="fa fa-twitter-square fa-lg"></i></a> &nbsp; `;
    }
    if (obj.fb) {
      str += `<a href="https://facebook.com/${
        obj.fb
      }"><i class="fa fa-facebook-square fa-lg"></i></a> &nbsp; `;
    }
    if (obj.ig) {
      str += `<a href="https://instagram.com/${
        obj.ig
      }"><i class="fa fa-instagram fa-lg"></i></a> &nbsp; `;
    }
    if (obj.sc) {
      str += `<a href="https://snapchat.com/${
        obj.sc
      }"><i class="fa fa-snapchat-square fa-lg"></i></a>`;
    }
    return str;
  }
*/



// WEBPACK FOOTER //
// ./src/helpers.js